// extracted by mini-css-extract-plugin
export default {"root":"h-scroll-container_root__ttMcj","placeHolderShimmer":"h-scroll-container_placeHolderShimmer__yVUNZ"};